import Vue from 'vue';
import store from 'store';
import SkyFonts from 'sky-fonts';

import 'sky-accordion';
import 'sky-crop';
import 'sky-form-editor';
import 'sky-gallery';
import 'sky-lightbox';
import 'sky-list';
import 'sky-overlay';
import 'sky-news';
import 'sky-reveal';
import 'sky-search';
import 'sky-sharethis';
import 'sky-print';
import 'sky-scheme';
import 'sky-svg';
import 'sky-swiper';
import 'sky-video';
import 'sky-window';

import 'ge-link';
import 'ge-list';
import 'ge-svg-hover';
import 'ge-cta-arrow';
import 'ge-image-filter';
import 'ge-menu';
import 'ge-menu-toggle';
import 'cookie-blocker';
import 'cookie-renew';

new Vue({
	el: '[sky-app]',
	store,
});


SkyFonts('googlefonts', ['Rubik:400,500,700']);



// WEBPACK FOOTER //
// ./scripts/app.js